import { Trans } from '@lingui/react/macro';
import { Button, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link, useRouteMatch } from 'react-router-dom';
import { useCompanyFeatures } from 'app/domains/companies/features/CompanyFeatures';
import { MessageWrapper } from './MessageWrapper';
import { useWorkflowCheck } from '../WorkflowCheckProvider';
import { useWorkflowCheckOutdated } from '../useWorkflowCheckOutdated';
export function WorkflowCheckOutdatedMessage() {
    const { type } = useWorkflowCheck();
    const { isApprovalOutdated, isSignatoryOutdated } = useWorkflowCheckOutdated();
    const { url } = useRouteMatch();
    const { isFeatureAvailable } = useCompanyFeatures();
    const isWorkflowsAvailable = isFeatureAvailable('DOCUMENT_ASSISTANT_WORKFLOWS');
    const approvalUrl = url.replace('/esigning', '/approval');
    if (!isWorkflowsAvailable) {
        return null;
    }
    if (type === 'approval' && isApprovalOutdated) {
        return (<MessageWrapper>
        <Typography $fontSize="tiny" $appearance="200">
          <Trans comment="Workflow check is outdated - Approval message">
            This document has been edited since the check for approval requirements was run. Please rerun the check.
          </Trans>
        </Typography>
      </MessageWrapper>);
    }
    // We also want to check in the signatory flow if approval is outdated
    // to let the user know that they should rerun the approval check.
    // Note: This check takes precedence over the default signatory outdated check.
    if (type === 'signatory' && isApprovalOutdated) {
        return (<MessageWrapper>
        <Typography $fontSize="tiny" $appearance="200">
          <Trans comment="Workflow check is outdated - Signatory with approval message">
            This document has been edited since the last rule check. Go to the Approval tab to run a new assessment.
          </Trans>
        </Typography>
        <Button as={Link} to={approvalUrl} size="xs" appearance="primary">
          <Trans comment="Workflow check is outdated - Go to approval">Go to approval</Trans>
          <Falcon icon="arrow-right"/>
        </Button>
      </MessageWrapper>);
    }
    if (type === 'signatory' && isSignatoryOutdated) {
        return (<MessageWrapper>
        <Typography $fontSize="tiny" $appearance="200">
          <Trans comment="Workflow check is outdated - Signatory message">
            This document has been edited since the check for signatory requirements was run. Please rerun the check.
          </Trans>
        </Typography>
      </MessageWrapper>);
    }
    return null;
}
